import { Grid } from "@material-ui/core";
import Popup from "../../../components/Popup";
import useFormPageStyles from '../../../components/FormPageStyles';

import { useEffect, useState } from "react";
import { Formik } from "formik";
import {
    Button,
    FormControl,
    Box,
} from "@material-ui/core";
import Select from "../../../components/Select";
import Autocomplete from '../../../components/Autocomplete';
import Input from "../../../components/Input";
import api from '../../../services/api';

export default function DeviceCreateModal({ openModalCreate, setModalCreate,
    refresh,
    setRefresh,
    setMessage,
}) {
    const pageClasses = useFormPageStyles();
    const [connectionType, setConnectionType] = useState("");
    const initialValues = {
        deviceName: "",
        zone: "",
        enabled: true,
        username: "",
        password: "",
        ip_address: "",
        port: "",
        mac_address: "",
        onvif_recording_stream: "main",
        onvif_recording_condition: "every_moment",
    };

    const [orgs, setOrgs] = useState([]);
    const [orgSearch, setOrgSearch] = useState('');
    const [org, setOrg] = useState(null);

    useEffect(() => {
        const findOrg = async () => {
            try {
                const result = await api.get('/organizational_structure/index', {
                    params: { search: orgSearch },
                });

                const { orgs } = result.data;

                setOrgs(orgs);
            }
            catch (err) {
                console.log(err.message);
            }
        };

        findOrg();
    }, [orgSearch]);


    const saveCustomInput = async (values) => {
        const { ...rest } = values

        try {
            const nonEmptyData = Object.entries(rest).reduce((acc, [key, value]) => {
                if (value !== null && value !== undefined) {
                    acc[key] = value;
                }
                return acc;
            }, {});

            const { deviceName, enabled, mac_address, port, password, ip_address, username } = nonEmptyData;

            await api.post(`/external_cam/create`, {
                name: deviceName,
                enabled: enabled,
                ip_address: ip_address,
                port: port,
                username: username,
                password: password,
                device_type: connectionType,
                mac_address: mac_address,
                org_id: org.id,

            })
            setRefresh(!refresh);
            setMessage({
                open: true,
                variant: 'success',
                text: `Dispositivo externo criado com sucesso!`,
            });
            setModalCreate(false)
        }
        catch (err) {
            setRefresh(!refresh);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
            setModalCreate(false)
        }
    };


    const handleClose = () => {
        setModalCreate(false);
    };



    const handleConnectionTypeChange = (event, resetForm) => {
        setConnectionType(event.target.value);
        resetForm();

    };

    return (
        <Popup
            openPopup={openModalCreate}
            setOpenPopup={setModalCreate}
            title="Cadastrar câmera"
            width="min(620px, 100%)"
            maxWidth="sm"
        >
            <Box
                pb="4"
                width="100%"
                display="flex"
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Formik
                    initialValues={initialValues}
                    onSubmit={saveCustomInput}
                >
                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm,
                    }) => (
                        <>
                            <form id="deviceForm" onSubmit={handleSubmit} style={{ width: '100%' }}>
                                <FormControl fullWidth>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Select
                                                label={"Tipo de conexão"}
                                                options={[
                                                    {
                                                        label: "Eagle-Eye",
                                                        value: "Eagle-Eye",
                                                    },
                                                    {
                                                        label: "Onvif",
                                                        value: "Onvif",
                                                    },
                                                    {
                                                        label: "RTSP",
                                                        value: "RTSP",
                                                    },
                                                ]}
                                                textFieldProps={{
                                                    required: true,
                                                    fullWidth: true,
                                                    name: "deviceType",
                                                    value: connectionType,
                                                    onChange: (event) => {
                                                        handleConnectionTypeChange(
                                                            event,
                                                            resetForm
                                                        );
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Input
                                                label="Nome do dispositivo:"
                                                textFieldProps={{
                                                    required: true,
                                                    name: "deviceName",
                                                    value: values.deviceName,
                                                    onChange:
                                                        handleChange,
                                                    fullWidth: true,
                                                }}
                                                placeholder="Nome do dispositivo"
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Select
                                                label={"Status"}
                                                options={[
                                                    {
                                                        label: "Ativado",
                                                        value: true,
                                                    },
                                                    {
                                                        label: "Desativado",
                                                        value: false,
                                                    },
                                                ]}
                                                textFieldProps={{
                                                    required: true,
                                                    fullWidth: true,
                                                    name: "enabled",
                                                    value: values.enabled,
                                                    onChange:
                                                        handleChange,
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Autocomplete
                                                label="Organização Parente"
                                                placeholder="Administração"
                                                id="parent_organization"
                                                options={orgs}
                                                getOptionLabel={({ name }) => name || ''}
                                                onChange={(_, value) => setOrg(value)}
                                                getOptionSelected={(option, value) => (option.name === value.name)}
                                                onInputChange={(_, value) => setOrgSearch(value)}
                                                value={org}
                                                fullWidth
                                                required={(values.role === 'employee')}
                                            />
                                        </Grid>

                                        {
                                            (connectionType === "Eagle-Eye") && (
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <Input
                                                        label="Endereço MAC:"
                                                        textFieldProps={{
                                                            required: true,
                                                            name: "mac_address",
                                                            value: values.mac_address,
                                                            onChange:
                                                                handleChange,
                                                            fullWidth: true,
                                                        }}
                                                    />
                                                </Grid>
                                            )
                                        }

                                        {
                                            (connectionType === "Onvif" || connectionType === "RTSP") && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Input
                                                            label="Nome do usuário:"
                                                            textFieldProps={{
                                                                required: true,
                                                                name: "username",
                                                                value: values.username,
                                                                onChange:
                                                                    handleChange,
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Input
                                                            label="Senha:"
                                                            textFieldProps={{
                                                                required: true,
                                                                name: "password",
                                                                type: "password",
                                                                value: values.password,
                                                                onChange:
                                                                    handleChange,
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Input
                                                            label="Endereço IP:"
                                                            textFieldProps={{
                                                                required: true,
                                                                name: "ip_address",
                                                                value: values.ip_address,
                                                                onChange:
                                                                    handleChange,
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Input
                                                            label="Porta:"
                                                            textFieldProps={{
                                                                required: true,
                                                                name: "port",
                                                                value: values.port,
                                                                onChange:
                                                                    handleChange,
                                                                fullWidth: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            )
                                        }
                                        {
                                            (connectionType === "Onvif") && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Select
                                                            label={"Stream de Gravação"}
                                                            options={[
                                                                {
                                                                    label: "Principal",
                                                                    value: "main",
                                                                },
                                                                {
                                                                    label: "Secundária",
                                                                    value: "sub",
                                                                },
                                                            ]}
                                                            textFieldProps={{
                                                                fullWidth: true,
                                                                name: "onvif_recording_stream",
                                                                value: values.onvif_recording_stream,
                                                                onChange:
                                                                    handleChange,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        <Select
                                                            label={"Condição de Gravação"}
                                                            options={[
                                                                {
                                                                    label: "Integral",
                                                                    value: "every_moment",
                                                                },
                                                                {
                                                                    label: "Detecção de Movimento",
                                                                    value: "motion_detection",
                                                                },
                                                            ]}
                                                            textFieldProps={{
                                                                fullWidth: true,
                                                                name: "onvif_recording_condition",
                                                                value: values.onvif_recording_condition,
                                                                onChange:
                                                                    handleChange,
                                                            }}
                                                        />
                                                    </Grid>
                                                </>
                                            )
                                        }
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} justify="flex-end" alignItems="center" style={{ borderTop: '1px solid #e5e7eb', paddingTop: 16, marginTop: 16 }}>
                                                <Grid item>
                                                    <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        disabled={connectionType === ""}
                                                        type="submit"
                                                        form="deviceForm"
                                                        color="primary"
                                                        variant="contained"
                                                        className={pageClasses.saveButton}
                                                    >
                                                        Cadastrar câmera
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </FormControl>
                            </form>
                        </>
                    )}
                </Formik>
            </Box>
        </Popup>
    );
}
